module.exports = __webpack_public_path__ + "media/images/covers/foundation/Foundation-Programme_mobile-banner-85613708b66281f76b23fff69f989f17.png";